{
  "123": 60301,
  "360": 58743,
  "10k": 59729,
  "10mp": 59730,
  "11mp": 59731,
  "12mp": 59732,
  "13mp": 59733,
  "14mp": 59734,
  "15mp": 59735,
  "16mp": 59736,
  "17mp": 59737,
  "18-up-rating": 63741,
  "18mp": 59738,
  "19mp": 59739,
  "1k": 59740,
  "1k-plus": 59741,
  "1x-mobiledata": 61389,
  "20mp": 59742,
  "21mp": 59743,
  "22mp": 59744,
  "23mp": 59745,
  "24mp": 59746,
  "2k": 59747,
  "2k-plus": 59748,
  "2mp": 59749,
  "30fps": 61390,
  "30fps-select": 61391,
  "3d-rotation": 59469,
  "3g-mobiledata": 61392,
  "3k": 59750,
  "3k-plus": 59751,
  "3mp": 59752,
  "3p": 61393,
  "4g-mobiledata": 61394,
  "4g-plus-mobiledata": 61395,
  "4k": 57458,
  "4k-plus": 59753,
  "4mp": 59754,
  "5g": 61240,
  "5k": 59755,
  "5k-plus": 59756,
  "5mp": 59757,
  "60fps": 61396,
  "60fps-select": 61397,
  "6-ft-apart": 61982,
  "6k": 59758,
  "6k-plus": 59759,
  "6mp": 59760,
  "7k": 59761,
  "7k-plus": 59762,
  "7mp": 59763,
  "8k": 59764,
  "8k-plus": 59765,
  "8mp": 59766,
  "9k": 59767,
  "9k-plus": 59768,
  "9mp": 59769,
  "abc": 60308,
  "ac-unit": 60219,
  "access-alarm": 57744,
  "access-alarms": 57745,
  "access-time": 57746,
  "access-time-filled": 61398,
  "accessibility": 59470,
  "accessibility-new": 59692,
  "accessible": 59668,
  "accessible-forward": 59700,
  "account-balance": 59471,
  "account-balance-wallet": 59472,
  "account-box": 59473,
  "account-circle": 59475,
  "account-tree": 59770,
  "ad-units": 61241,
  "adb": 58894,
  "add": 57669,
  "add-a-photo": 58425,
  "add-alarm": 57747,
  "add-alert": 57347,
  "add-box": 57670,
  "add-business": 59177,
  "add-call": 57576,
  "add-card": 60294,
  "add-chart": 59771,
  "add-circle": 57671,
  "add-circle-outline": 57672,
  "add-comment": 57958,
  "add-home": 63723,
  "add-home-work": 63725,
  "add-ic-call": 59772,
  "add-link": 57720,
  "add-location": 58727,
  "add-location-alt": 61242,
  "add-moderator": 59773,
  "add-photo-alternate": 58430,
  "add-reaction": 57811,
  "add-road": 61243,
  "add-shopping-cart": 59476,
  "add-task": 62010,
  "add-to-drive": 58972,
  "add-to-home-screen": 57854,
  "add-to-photos": 58269,
  "add-to-queue": 57436,
  "addchart": 61244,
  "adf-scanner": 60122,
  "adjust": 58270,
  "admin-panel-settings": 61245,
  "adobe": 60054,
  "ads-click": 59234,
  "agriculture": 60025,
  "air": 61400,
  "airline-seat-flat": 58928,
  "airline-seat-flat-angled": 58929,
  "airline-seat-individual-suite": 58930,
  "airline-seat-legroom-extra": 58931,
  "airline-seat-legroom-normal": 58932,
  "airline-seat-legroom-reduced": 58933,
  "airline-seat-recline-extra": 58934,
  "airline-seat-recline-normal": 58935,
  "airline-stops": 59344,
  "airlines": 59338,
  "airplane-ticket": 61401,
  "airplanemode-active": 57749,
  "airplanemode-inactive": 57748,
  "airplanemode-off": 57748,
  "airplanemode-on": 57749,
  "airplay": 57429,
  "airport-shuttle": 60220,
  "alarm": 59477,
  "alarm-add": 59478,
  "alarm-off": 59479,
  "alarm-on": 59480,
  "album": 57369,
  "align-horizontal-center": 57359,
  "align-horizontal-left": 57357,
  "align-horizontal-right": 57360,
  "align-vertical-bottom": 57365,
  "align-vertical-center": 57361,
  "align-vertical-top": 57356,
  "all-inbox": 59775,
  "all-inclusive": 60221,
  "all-out": 59659,
  "alt-route": 61828,
  "alternate-email": 57574,
  "amp-stories": 59923,
  "analytics": 61246,
  "anchor": 61901,
  "android": 59481,
  "animation": 59164,
  "announcement": 59482,
  "aod": 61402,
  "apartment": 59968,
  "api": 61879,
  "app-blocking": 61247,
  "app-registration": 61248,
  "app-settings-alt": 61249,
  "app-shortcut": 60132,
  "apple": 60032,
  "approval": 59778,
  "apps": 58819,
  "apps-outage": 59340,
  "architecture": 59963,
  "archive": 57673,
  "area-chart": 59248,
  "arrow-back": 58820,
  "arrow-back-ios": 58848,
  "arrow-back-ios-new": 58090,
  "arrow-circle-down": 61825,
  "arrow-circle-left": 60071,
  "arrow-circle-right": 60074,
  "arrow-circle-up": 61826,
  "arrow-downward": 58843,
  "arrow-drop-down": 58821,
  "arrow-drop-down-circle": 58822,
  "arrow-drop-up": 58823,
  "arrow-forward": 58824,
  "arrow-forward-ios": 58849,
  "arrow-left": 58846,
  "arrow-outward": 63694,
  "arrow-right": 58847,
  "arrow-right-alt": 59713,
  "arrow-upward": 58840,
  "art-track": 57440,
  "article": 61250,
  "aspect-ratio": 59483,
  "assessment": 59484,
  "assignment": 59485,
  "assignment-add": 63560,
  "assignment-ind": 59486,
  "assignment-late": 59487,
  "assignment-return": 59488,
  "assignment-returned": 59489,
  "assignment-turned-in": 59490,
  "assist-walker": 63701,
  "assistant": 58271,
  "assistant-direction": 59784,
  "assistant-navigation": 59785,
  "assistant-photo": 58272,
  "assured-workload": 60271,
  "atm": 58739,
  "attach-email": 59998,
  "attach-file": 57894,
  "attach-money": 57895,
  "attachment": 58044,
  "attractions": 59986,
  "attribution": 61403,
  "audio-file": 60290,
  "audiotrack": 58273,
  "auto-awesome": 58975,
  "auto-awesome-mosaic": 58976,
  "auto-awesome-motion": 58977,
  "auto-delete": 59980,
  "auto-fix-high": 58979,
  "auto-fix-normal": 58980,
  "auto-fix-off": 58981,
  "auto-graph": 58619,
  "auto-mode": 60448,
  "auto-stories": 58982,
  "autofps-select": 61404,
  "autorenew": 59491,
  "av-timer": 57371,
  "baby-changing-station": 61851,
  "back-hand": 59236,
  "backpack": 61852,
  "backspace": 57674,
  "backup": 59492,
  "backup-table": 61251,
  "badge": 60007,
  "bakery-dining": 59987,
  "balance": 60150,
  "balcony": 58767,
  "ballot": 57714,
  "bar-chart": 57963,
  "barcode-reader": 63580,
  "batch-prediction": 61685,
  "bathroom": 61405,
  "bathtub": 59969,
  "battery-0-bar": 60380,
  "battery-1-bar": 60377,
  "battery-2-bar": 60384,
  "battery-3-bar": 60381,
  "battery-4-bar": 60386,
  "battery-5-bar": 60372,
  "battery-6-bar": 60370,
  "battery-alert": 57756,
  "battery-charging-full": 57763,
  "battery-full": 57764,
  "battery-saver": 61406,
  "battery-std": 57765,
  "battery-unknown": 57766,
  "beach-access": 60222,
  "bed": 61407,
  "bedroom-baby": 61408,
  "bedroom-child": 61409,
  "bedroom-parent": 61410,
  "bedtime": 61252,
  "bedtime-off": 60278,
  "beenhere": 58669,
  "bento": 61940,
  "bike-scooter": 61253,
  "biotech": 59962,
  "blender": 61411,
  "blind": 63702,
  "blinds": 57990,
  "blinds-closed": 60447,
  "block": 57675,
  "block-flipped": 61254,
  "bloodtype": 61412,
  "bluetooth": 57767,
  "bluetooth-audio": 58895,
  "bluetooth-connected": 57768,
  "bluetooth-disabled": 57769,
  "bluetooth-drive": 61413,
  "bluetooth-searching": 57770,
  "blur-circular": 58274,
  "blur-linear": 58275,
  "blur-off": 58276,
  "blur-on": 58277,
  "bolt": 59915,
  "book": 59493,
  "book-online": 61975,
  "bookmark": 59494,
  "bookmark-add": 58776,
  "bookmark-added": 58777,
  "bookmark-border": 59495,
  "bookmark-outline": 59495,
  "bookmark-remove": 58778,
  "bookmarks": 59787,
  "border-all": 57896,
  "border-bottom": 57897,
  "border-clear": 57898,
  "border-color": 57899,
  "border-horizontal": 57900,
  "border-inner": 57901,
  "border-left": 57902,
  "border-outer": 57903,
  "border-right": 57904,
  "border-style": 57905,
  "border-top": 57906,
  "border-vertical": 57907,
  "boy": 60263,
  "branding-watermark": 57451,
  "breakfast-dining": 59988,
  "brightness-1": 58278,
  "brightness-2": 58279,
  "brightness-3": 58280,
  "brightness-4": 58281,
  "brightness-5": 58282,
  "brightness-6": 58283,
  "brightness-7": 58284,
  "brightness-auto": 57771,
  "brightness-high": 57772,
  "brightness-low": 57773,
  "brightness-medium": 57774,
  "broadcast-on-home": 63736,
  "broadcast-on-personal": 63737,
  "broken-image": 58285,
  "browse-gallery": 60369,
  "browser-not-supported": 61255,
  "browser-updated": 59343,
  "brunch-dining": 60019,
  "brush": 58286,
  "bubble-chart": 59101,
  "bug-report": 59496,
  "build": 59497,
  "build-circle": 61256,
  "bungalow": 58769,
  "burst-mode": 58428,
  "bus-alert": 59791,
  "business": 57519,
  "business-center": 60223,
  "cabin": 58761,
  "cable": 61414,
  "cached": 59498,
  "cake": 59369,
  "calculate": 59999,
  "calendar-month": 60364,
  "calendar-today": 59701,
  "calendar-view-day": 59702,
  "calendar-view-month": 61415,
  "calendar-view-week": 61416,
  "call": 57520,
  "call-end": 57521,
  "call-made": 57522,
  "call-merge": 57523,
  "call-missed": 57524,
  "call-missed-outgoing": 57572,
  "call-received": 57525,
  "call-split": 57526,
  "call-to-action": 57452,
  "camera": 58287,
  "camera-alt": 58288,
  "camera-enhance": 59644,
  "camera-front": 58289,
  "camera-indoor": 61417,
  "camera-outdoor": 61418,
  "camera-rear": 58290,
  "camera-roll": 58291,
  "cameraswitch": 61419,
  "campaign": 61257,
  "cancel": 58825,
  "cancel-presentation": 57577,
  "cancel-schedule-send": 59961,
  "candlestick-chart": 60116,
  "car-crash": 60402,
  "car-rental": 59989,
  "car-repair": 59990,
  "card-giftcard": 59638,
  "card-membership": 59639,
  "card-travel": 59640,
  "carpenter": 61944,
  "cases": 59794,
  "casino": 60224,
  "cast": 58119,
  "cast-connected": 58120,
  "cast-for-education": 61420,
  "castle": 60081,
  "catching-pokemon": 58632,
  "category": 58740,
  "celebration": 60005,
  "cell-tower": 60346,
  "cell-wifi": 57580,
  "center-focus-strong": 58292,
  "center-focus-weak": 58293,
  "chair": 61421,
  "chair-alt": 61422,
  "chalet": 58757,
  "change-circle": 58087,
  "change-history": 59499,
  "charging-station": 61853,
  "chat": 57527,
  "chat-bubble": 57546,
  "chat-bubble-outline": 57547,
  "check": 58826,
  "check-box": 59444,
  "check-box-outline-blank": 59445,
  "check-circle": 59500,
  "check-circle-outline": 59693,
  "checklist": 59057,
  "checklist-rtl": 59059,
  "checkroom": 61854,
  "chevron-left": 58827,
  "chevron-right": 58828,
  "child-care": 60225,
  "child-friendly": 60226,
  "chrome-reader-mode": 59501,
  "church": 60078,
  "circle": 61258,
  "circle-notifications": 59796,
  "class": 59502,
  "clean-hands": 61983,
  "cleaning-services": 61695,
  "clear": 57676,
  "clear-all": 57528,
  "close": 58829,
  "close-fullscreen": 61903,
  "closed-caption": 57372,
  "closed-caption-disabled": 61916,
  "closed-caption-off": 59798,
  "cloud": 58045,
  "cloud-circle": 58046,
  "cloud-done": 58047,
  "cloud-download": 58048,
  "cloud-off": 58049,
  "cloud-queue": 58050,
  "cloud-sync": 60250,
  "cloud-upload": 58051,
  "cloudy-snowing": 59408,
  "co2": 59312,
  "co-present": 60144,
  "code": 59503,
  "code-off": 58611,
  "coffee": 61423,
  "coffee-maker": 61424,
  "collections": 58294,
  "collections-bookmark": 58417,
  "color-lens": 58295,
  "colorize": 58296,
  "comment": 57529,
  "comment-bank": 59982,
  "comments-disabled": 59298,
  "commit": 60149,
  "commute": 59712,
  "compare": 58297,
  "compare-arrows": 59669,
  "compass-calibration": 58748,
  "compost": 59233,
  "compress": 59725,
  "computer": 58122,
  "confirmation-num": 58936,
  "confirmation-number": 58936,
  "connect-without-contact": 61987,
  "connected-tv": 59800,
  "connecting-airports": 59337,
  "construction": 59964,
  "contact-emergency": 63697,
  "contact-mail": 57552,
  "contact-page": 61998,
  "contact-phone": 57551,
  "contact-support": 59724,
  "contactless": 60017,
  "contacts": 57530,
  "content-copy": 57677,
  "content-cut": 57678,
  "content-paste": 57679,
  "content-paste-go": 60046,
  "content-paste-off": 58616,
  "content-paste-search": 60059,
  "contrast": 60215,
  "control-camera": 57460,
  "control-point": 58298,
  "control-point-duplicate": 58299,
  "conveyor-belt": 63591,
  "cookie": 60076,
  "copy-all": 58092,
  "copyright": 59660,
  "coronavirus": 61985,
  "corporate-fare": 61904,
  "cottage": 58759,
  "countertops": 61943,
  "create": 57680,
  "create-new-folder": 58060,
  "credit-card": 59504,
  "credit-card-off": 58612,
  "credit-score": 61425,
  "crib": 58760,
  "crisis-alert": 60393,
  "crop": 58302,
  "crop-16-9": 58300,
  "crop-3-2": 58301,
  "crop-5-4": 58303,
  "crop-7-5": 58304,
  "crop-din": 58305,
  "crop-free": 58306,
  "crop-landscape": 58307,
  "crop-original": 58308,
  "crop-portrait": 58309,
  "crop-rotate": 58423,
  "crop-square": 58310,
  "cruelty-free": 59289,
  "css": 60307,
  "currency-bitcoin": 60357,
  "currency-exchange": 60272,
  "currency-franc": 60154,
  "currency-lira": 60143,
  "currency-pound": 60145,
  "currency-ruble": 60140,
  "currency-rupee": 60151,
  "currency-yen": 60155,
  "currency-yuan": 60153,
  "curtains": 60446,
  "curtains-closed": 60445,
  "cyclone": 60373,
  "dangerous": 59802,
  "dark-mode": 58652,
  "dashboard": 59505,
  "dashboard-customize": 59803,
  "data-array": 60113,
  "data-exploration": 59247,
  "data-object": 60115,
  "data-saver-off": 61426,
  "data-saver-on": 61427,
  "data-thresholding": 60319,
  "data-usage": 57775,
  "dataset": 63726,
  "dataset-linked": 63727,
  "date-range": 59670,
  "deblur": 60279,
  "deck": 59970,
  "dehaze": 58311,
  "delete": 59506,
  "delete-forever": 59691,
  "delete-outline": 59694,
  "delete-sweep": 57708,
  "delivery-dining": 60018,
  "density-large": 60329,
  "density-medium": 60318,
  "density-small": 60328,
  "departure-board": 58742,
  "description": 59507,
  "deselect": 60342,
  "design-services": 61706,
  "desk": 63732,
  "desktop-access-disabled": 59805,
  "desktop-mac": 58123,
  "desktop-windows": 58124,
  "details": 58312,
  "developer-board": 58125,
  "developer-board-off": 58623,
  "developer-mode": 57776,
  "device-hub": 58165,
  "device-thermostat": 57855,
  "device-unknown": 58169,
  "devices": 57777,
  "devices-fold": 60382,
  "devices-other": 58167,
  "dew-point": 63609,
  "dialer-sip": 57531,
  "dialpad": 57532,
  "diamond": 60117,
  "difference": 60285,
  "dining": 61428,
  "dinner-dining": 59991,
  "directions": 58670,
  "directions-bike": 58671,
  "directions-boat": 58674,
  "directions-boat-filled": 61429,
  "directions-bus": 58672,
  "directions-bus-filled": 61430,
  "directions-car": 58673,
  "directions-car-filled": 61431,
  "directions-ferry": 58674,
  "directions-off": 61711,
  "directions-railway": 58676,
  "directions-railway-filled": 61432,
  "directions-run": 58726,
  "directions-subway": 58675,
  "directions-subway-filled": 61433,
  "directions-train": 58676,
  "directions-transit": 58677,
  "directions-transit-filled": 61434,
  "directions-walk": 58678,
  "dirty-lens": 61259,
  "disabled-by-default": 62000,
  "disabled-visible": 59246,
  "disc-full": 58896,
  "discord": 60012,
  "discount": 60361,
  "display-settings": 60311,
  "diversity-1": 63703,
  "diversity-2": 63704,
  "diversity-3": 63705,
  "dnd-forwardslash": 58897,
  "dns": 59509,
  "do-disturb": 61580,
  "do-disturb-alt": 61581,
  "do-disturb-off": 61582,
  "do-disturb-on": 61583,
  "do-not-disturb": 58898,
  "do-not-disturb-alt": 58897,
  "do-not-disturb-off": 58947,
  "do-not-disturb-on": 58948,
  "do-not-disturb-on-total-silence": 61435,
  "do-not-step": 61855,
  "do-not-touch": 61872,
  "dock": 58126,
  "document-scanner": 58874,
  "domain": 59374,
  "domain-add": 60258,
  "domain-disabled": 57583,
  "domain-verification": 61260,
  "done": 59510,
  "done-all": 59511,
  "done-outline": 59695,
  "donut-large": 59671,
  "donut-small": 59672,
  "door-back": 61436,
  "door-front": 61437,
  "door-sliding": 61438,
  "doorbell": 61439,
  "double-arrow": 59984,
  "downhill-skiing": 58633,
  "download": 61584,
  "download-done": 61585,
  "download-for-offline": 61440,
  "downloading": 61441,
  "drafts": 57681,
  "drag-handle": 57949,
  "drag-indicator": 59717,
  "draw": 59206,
  "drive-eta": 58899,
  "drive-file-move": 58997,
  "drive-file-move-outline": 59809,
  "drive-file-move-rtl": 59245,
  "drive-file-rename-outline": 59810,
  "drive-folder-upload": 59811,
  "dry": 61875,
  "dry-cleaning": 59992,
  "duo": 59813,
  "dvr": 57778,
  "dynamic-feed": 59924,
  "dynamic-form": 61887,
  "e-mobiledata": 61442,
  "earbuds": 61443,
  "earbuds-battery": 61444,
  "east": 61919,
  "eco": 59957,
  "edgesensor-high": 61445,
  "edgesensor-low": 61446,
  "edit": 58313,
  "edit-attributes": 58744,
  "edit-calendar": 59202,
  "edit-document": 63628,
  "edit-location": 58728,
  "edit-location-alt": 57797,
  "edit-note": 59205,
  "edit-notifications": 58661,
  "edit-off": 59728,
  "edit-road": 61261,
  "edit-square": 63629,
  "egg": 60108,
  "egg-alt": 60104,
  "eject": 59643,
  "elderly": 61978,
  "elderly-woman": 60265,
  "electric-bike": 60187,
  "electric-bolt": 60444,
  "electric-car": 60188,
  "electric-meter": 60443,
  "electric-moped": 60189,
  "electric-rickshaw": 60190,
  "electric-scooter": 60191,
  "electrical-services": 61698,
  "elevator": 61856,
  "email": 57534,
  "emergency": 57835,
  "emergency-recording": 60404,
  "emergency-share": 60406,
  "emoji-emotions": 59938,
  "emoji-events": 59939,
  "emoji-flags": 59930,
  "emoji-food-beverage": 59931,
  "emoji-nature": 59932,
  "emoji-objects": 59940,
  "emoji-people": 59933,
  "emoji-symbols": 59934,
  "emoji-transportation": 59935,
  "energy-savings-leaf": 60442,
  "engineering": 59965,
  "enhance-photo-translate": 59644,
  "enhanced-encryption": 58943,
  "equalizer": 57373,
  "error": 57344,
  "error-outline": 57345,
  "escalator": 61857,
  "escalator-warning": 61868,
  "euro": 59925,
  "euro-symbol": 59686,
  "ev-station": 58733,
  "event": 59512,
  "event-available": 58900,
  "event-busy": 58901,
  "event-note": 58902,
  "event-repeat": 60283,
  "event-seat": 59651,
  "exit-to-app": 59513,
  "expand": 59727,
  "expand-circle-down": 59341,
  "expand-less": 58830,
  "expand-more": 58831,
  "explicit": 57374,
  "explore": 59514,
  "explore-off": 59816,
  "exposure": 58314,
  "exposure-minus-1": 58315,
  "exposure-minus-2": 58316,
  "exposure-neg-1": 58315,
  "exposure-neg-2": 58316,
  "exposure-plus-1": 58317,
  "exposure-plus-2": 58318,
  "exposure-zero": 58319,
  "extension": 59515,
  "extension-off": 58613,
  "face": 59516,
  "face-2": 63706,
  "face-3": 63707,
  "face-4": 63708,
  "face-5": 63709,
  "face-6": 63710,
  "face-retouching-natural": 61262,
  "face-retouching-off": 61447,
  "facebook": 62004,
  "fact-check": 61637,
  "factory": 60348,
  "family-restroom": 61858,
  "fast-forward": 57375,
  "fast-rewind": 57376,
  "fastfood": 58746,
  "favorite": 59517,
  "favorite-border": 59518,
  "favorite-outline": 59518,
  "fax": 60120,
  "featured-play-list": 57453,
  "featured-video": 57454,
  "feed": 61449,
  "feedback": 59519,
  "female": 58768,
  "fence": 61942,
  "festival": 60008,
  "fiber-dvr": 57437,
  "fiber-manual-record": 57441,
  "fiber-new": 57438,
  "fiber-pin": 57450,
  "fiber-smart-record": 57442,
  "file-copy": 57715,
  "file-download": 58052,
  "file-download-done": 59818,
  "file-download-off": 58622,
  "file-open": 60147,
  "file-present": 59918,
  "file-upload": 58054,
  "file-upload-off": 63622,
  "filter": 58323,
  "filter-1": 58320,
  "filter-2": 58321,
  "filter-3": 58322,
  "filter-4": 58324,
  "filter-5": 58325,
  "filter-6": 58326,
  "filter-7": 58327,
  "filter-8": 58328,
  "filter-9": 58329,
  "filter-9-plus": 58330,
  "filter-alt": 61263,
  "filter-alt-off": 60210,
  "filter-b-and-w": 58331,
  "filter-center-focus": 58332,
  "filter-drama": 58333,
  "filter-frames": 58334,
  "filter-hdr": 58335,
  "filter-list": 57682,
  "filter-list-alt": 59726,
  "filter-list-off": 60247,
  "filter-none": 58336,
  "filter-tilt-shift": 58338,
  "filter-vintage": 58339,
  "find-in-page": 59520,
  "find-replace": 59521,
  "fingerprint": 59661,
  "fire-extinguisher": 61912,
  "fire-hydrant": 61859,
  "fire-hydrant-alt": 63729,
  "fire-truck": 63730,
  "fireplace": 59971,
  "first-page": 58844,
  "fit-screen": 59920,
  "fitbit": 59435,
  "fitness-center": 60227,
  "flag": 57683,
  "flag-circle": 60152,
  "flaky": 61264,
  "flare": 58340,
  "flash-auto": 58341,
  "flash-off": 58342,
  "flash-on": 58343,
  "flashlight-off": 61450,
  "flashlight-on": 61451,
  "flatware": 61452,
  "flight": 58681,
  "flight-class": 59339,
  "flight-land": 59652,
  "flight-takeoff": 59653,
  "flip": 58344,
  "flip-camera-android": 59959,
  "flip-camera-ios": 59960,
  "flip-to-back": 59522,
  "flip-to-front": 59523,
  "flood": 60390,
  "flourescent": 61453,
  "fluorescent": 60465,
  "flutter-dash": 57355,
  "fmd-bad": 61454,
  "fmd-good": 61455,
  "foggy": 59416,
  "folder": 58055,
  "folder-copy": 60349,
  "folder-delete": 60212,
  "folder-off": 60291,
  "folder-open": 58056,
  "folder-shared": 58057,
  "folder-special": 58903,
  "folder-zip": 60204,
  "follow-the-signs": 61986,
  "font-download": 57703,
  "font-download-off": 58617,
  "food-bank": 61938,
  "forest": 60057,
  "fork-left": 60320,
  "fork-right": 60332,
  "forklift": 63592,
  "format-align-center": 57908,
  "format-align-justify": 57909,
  "format-align-left": 57910,
  "format-align-right": 57911,
  "format-bold": 57912,
  "format-clear": 57913,
  "format-color-fill": 57914,
  "format-color-reset": 57915,
  "format-color-text": 57916,
  "format-indent-decrease": 57917,
  "format-indent-increase": 57918,
  "format-italic": 57919,
  "format-line-spacing": 57920,
  "format-list-bulleted": 57921,
  "format-list-bulleted-add": 63561,
  "format-list-numbered": 57922,
  "format-list-numbered-rtl": 57959,
  "format-overline": 60261,
  "format-paint": 57923,
  "format-quote": 57924,
  "format-shapes": 57950,
  "format-size": 57925,
  "format-strikethrough": 57926,
  "format-textdirection-l-to-r": 57927,
  "format-textdirection-r-to-l": 57928,
  "format-underline": 57929,
  "format-underlined": 57929,
  "fort": 60077,
  "forum": 57535,
  "forward": 57684,
  "forward-10": 57430,
  "forward-30": 57431,
  "forward-5": 57432,
  "forward-to-inbox": 61831,
  "foundation": 61952,
  "free-breakfast": 60228,
  "free-cancellation": 59208,
  "front-hand": 59241,
  "front-loader": 63593,
  "fullscreen": 58832,
  "fullscreen-exit": 58833,
  "functions": 57930,
  "g-mobiledata": 61456,
  "g-translate": 59687,
  "gamepad": 58127,
  "games": 57377,
  "garage": 61457,
  "gas-meter": 60441,
  "gavel": 59662,
  "generating-tokens": 59209,
  "gesture": 57685,
  "get-app": 59524,
  "gif": 59656,
  "gif-box": 59299,
  "girl": 60264,
  "gite": 58763,
  "goat": 1114109,
  "golf-course": 60229,
  "gpp-bad": 61458,
  "gpp-good": 61459,
  "gpp-maybe": 61460,
  "gps-fixed": 57779,
  "gps-not-fixed": 57780,
  "gps-off": 57781,
  "grade": 59525,
  "gradient": 58345,
  "grading": 59983,
  "grain": 58346,
  "graphic-eq": 57784,
  "grass": 61957,
  "grid-3x3": 61461,
  "grid-4x4": 61462,
  "grid-goldenratio": 61463,
  "grid-off": 58347,
  "grid-on": 58348,
  "grid-view": 59824,
  "group": 59375,
  "group-add": 59376,
  "group-off": 59207,
  "group-remove": 59309,
  "group-work": 59526,
  "groups": 62003,
  "groups-2": 63711,
  "groups-3": 63712,
  "h-mobiledata": 61464,
  "h-plus-mobiledata": 61465,
  "hail": 59825,
  "handshake": 60363,
  "handyman": 61707,
  "hardware": 59993,
  "hd": 57426,
  "hdr-auto": 61466,
  "hdr-auto-select": 61467,
  "hdr-enhanced-select": 61265,
  "hdr-off": 58349,
  "hdr-off-select": 61468,
  "hdr-on": 58350,
  "hdr-on-select": 61469,
  "hdr-plus": 61470,
  "hdr-strong": 58353,
  "hdr-weak": 58354,
  "headphones": 61471,
  "headphones-battery": 61472,
  "headset": 58128,
  "headset-mic": 58129,
  "headset-off": 58170,
  "healing": 58355,
  "health-and-safety": 57813,
  "hearing": 57379,
  "hearing-disabled": 61700,
  "heart-broken": 60098,
  "heat-pump": 60440,
  "height": 59926,
  "help": 59527,
  "help-center": 61888,
  "help-outline": 59645,
  "hevc": 61473,
  "hexagon": 60217,
  "hide-image": 61474,
  "hide-source": 61475,
  "high-quality": 57380,
  "highlight": 57951,
  "highlight-alt": 61266,
  "highlight-off": 59528,
  "highlight-remove": 59528,
  "hiking": 58634,
  "history": 59529,
  "history-edu": 59966,
  "history-toggle-off": 61821,
  "hive": 60070,
  "hls": 60298,
  "hls-off": 60300,
  "holiday-village": 58762,
  "home": 59530,
  "home-filled": 59826,
  "home-max": 61476,
  "home-mini": 61477,
  "home-repair-service": 61696,
  "home-work": 59913,
  "horizontal-distribute": 57364,
  "horizontal-rule": 61704,
  "horizontal-split": 59719,
  "hot-tub": 60230,
  "hotel": 58682,
  "hotel-class": 59203,
  "hourglass-bottom": 59996,
  "hourglass-disabled": 61267,
  "hourglass-empty": 59531,
  "hourglass-full": 59532,
  "hourglass-top": 59995,
  "house": 59972,
  "house-siding": 61954,
  "houseboat": 58756,
  "how-to-reg": 57716,
  "how-to-vote": 57717,
  "html": 60286,
  "http": 59650,
  "https": 59533,
  "hub": 59892,
  "hvac": 61710,
  "ice-skating": 58635,
  "icecream": 60009,
  "image": 58356,
  "image-aspect-ratio": 58357,
  "image-not-supported": 61718,
  "image-search": 58431,
  "imagesearch-roller": 59828,
  "import-contacts": 57568,
  "import-export": 57539,
  "important-devices": 59666,
  "inbox": 57686,
  "incomplete-circle": 59291,
  "indeterminate-check-box": 59657,
  "info": 59534,
  "info-outline": 59535,
  "input": 59536,
  "insert-chart": 57931,
  "insert-chart-outlined": 57962,
  "insert-comment": 57932,
  "insert-drive-file": 57933,
  "insert-emoticon": 57934,
  "insert-invitation": 57935,
  "insert-link": 57936,
  "insert-page-break": 60106,
  "insert-photo": 57937,
  "insights": 61586,
  "install-desktop": 60273,
  "install-mobile": 60274,
  "integration-instructions": 61268,
  "interests": 59336,
  "interpreter-mode": 59451,
  "inventory": 57721,
  "inventory-2": 57761,
  "invert-colors": 59537,
  "invert-colors-off": 57540,
  "invert-colors-on": 59537,
  "ios-share": 59064,
  "iron": 58755,
  "iso": 58358,
  "javascript": 60284,
  "join-full": 60139,
  "join-inner": 60148,
  "join-left": 60146,
  "join-right": 60138,
  "kayaking": 58636,
  "kebab-dining": 59458,
  "key": 59196,
  "key-off": 60292,
  "keyboard": 58130,
  "keyboard-alt": 61480,
  "keyboard-arrow-down": 58131,
  "keyboard-arrow-left": 58132,
  "keyboard-arrow-right": 58133,
  "keyboard-arrow-up": 58134,
  "keyboard-backspace": 58135,
  "keyboard-capslock": 58136,
  "keyboard-command": 60128,
  "keyboard-command-key": 60135,
  "keyboard-control": 58835,
  "keyboard-control-key": 60134,
  "keyboard-double-arrow-down": 60112,
  "keyboard-double-arrow-left": 60099,
  "keyboard-double-arrow-right": 60105,
  "keyboard-double-arrow-up": 60111,
  "keyboard-hide": 58138,
  "keyboard-option": 60127,
  "keyboard-option-key": 60136,
  "keyboard-return": 58139,
  "keyboard-tab": 58140,
  "keyboard-voice": 58141,
  "king-bed": 59973,
  "kitchen": 60231,
  "kitesurfing": 58637,
  "label": 59538,
  "label-important": 59703,
  "label-important-outline": 59720,
  "label-off": 59830,
  "label-outline": 59539,
  "lan": 60207,
  "landscape": 58359,
  "landslide": 60375,
  "language": 59540,
  "laptop": 58142,
  "laptop-chromebook": 58143,
  "laptop-mac": 58144,
  "laptop-windows": 58145,
  "last-page": 58845,
  "launch": 59541,
  "layers": 58683,
  "layers-clear": 58684,
  "leaderboard": 61964,
  "leak-add": 58360,
  "leak-remove": 58361,
  "leave-bags-at-home": 61979,
  "legend-toggle": 61723,
  "lens": 58362,
  "lens-blur": 61481,
  "library-add": 57390,
  "library-add-check": 59831,
  "library-books": 57391,
  "library-music": 57392,
  "light": 61482,
  "light-mode": 58648,
  "lightbulb": 57584,
  "lightbulb-circle": 60414,
  "lightbulb-outline": 59663,
  "line-axis": 60058,
  "line-style": 59673,
  "line-weight": 59674,
  "linear-scale": 57952,
  "link": 57687,
  "link-off": 57711,
  "linked-camera": 58424,
  "liquor": 60000,
  "list": 59542,
  "list-alt": 57582,
  "live-help": 57542,
  "live-tv": 58937,
  "living": 61483,
  "local-activity": 58687,
  "local-airport": 58685,
  "local-atm": 58686,
  "local-attraction": 58687,
  "local-bar": 58688,
  "local-cafe": 58689,
  "local-car-wash": 58690,
  "local-convenience-store": 58691,
  "local-dining": 58710,
  "local-drink": 58692,
  "local-fire-department": 61269,
  "local-florist": 58693,
  "local-gas-station": 58694,
  "local-grocery-store": 58695,
  "local-hospital": 58696,
  "local-hotel": 58697,
  "local-laundry-service": 58698,
  "local-library": 58699,
  "local-mall": 58700,
  "local-movies": 58701,
  "local-offer": 58702,
  "local-parking": 58703,
  "local-pharmacy": 58704,
  "local-phone": 58705,
  "local-pizza": 58706,
  "local-play": 58707,
  "local-police": 61270,
  "local-post-office": 58708,
  "local-print-shop": 58709,
  "local-printshop": 58709,
  "local-restaurant": 58710,
  "local-see": 58711,
  "local-shipping": 58712,
  "local-taxi": 58713,
  "location-city": 59377,
  "location-disabled": 57782,
  "location-history": 58714,
  "location-off": 57543,
  "location-on": 57544,
  "location-pin": 61915,
  "location-searching": 57783,
  "lock": 59543,
  "lock-clock": 61271,
  "lock-open": 59544,
  "lock-outline": 59545,
  "lock-person": 63731,
  "lock-reset": 60126,
  "login": 60023,
  "logo-dev": 60118,
  "logout": 59834,
  "looks": 58364,
  "looks-3": 58363,
  "looks-4": 58365,
  "looks-5": 58366,
  "looks-6": 58367,
  "looks-one": 58368,
  "looks-two": 58369,
  "loop": 57384,
  "loupe": 58370,
  "low-priority": 57709,
  "loyalty": 59546,
  "lte-mobiledata": 61484,
  "lte-plus-mobiledata": 61485,
  "luggage": 62005,
  "lunch-dining": 60001,
  "lyrics": 60427,
  "macro-off": 63698,
  "mail": 57688,
  "mail-lock": 60426,
  "mail-outline": 57569,
  "male": 58766,
  "man": 58603,
  "man-2": 63713,
  "man-3": 63714,
  "man-4": 63715,
  "manage-accounts": 61486,
  "manage-history": 60391,
  "manage-search": 61487,
  "map": 58715,
  "maps-home-work": 61488,
  "maps-ugc": 61272,
  "margin": 59835,
  "mark-as-unread": 59836,
  "mark-chat-read": 61835,
  "mark-chat-unread": 61833,
  "mark-email-read": 61836,
  "mark-email-unread": 61834,
  "mark-unread-chat-alt": 60317,
  "markunread": 57689,
  "markunread-mailbox": 59547,
  "masks": 61976,
  "maximize": 59696,
  "media-bluetooth-off": 61489,
  "media-bluetooth-on": 61490,
  "mediation": 61351,
  "medical-information": 60397,
  "medical-services": 61705,
  "medication": 61491,
  "medication-liquid": 60039,
  "meeting-room": 60239,
  "memory": 58146,
  "menu": 58834,
  "menu-book": 59929,
  "menu-open": 59837,
  "merge": 60312,
  "merge-type": 57938,
  "message": 57545,
  "messenger": 57546,
  "messenger-outline": 57547,
  "mic": 57385,
  "mic-external-off": 61273,
  "mic-external-on": 61274,
  "mic-none": 57386,
  "mic-off": 57387,
  "microwave": 61956,
  "military-tech": 59967,
  "minimize": 59697,
  "minor-crash": 60401,
  "miscellaneous-services": 61708,
  "missed-video-call": 57459,
  "mms": 58904,
  "mobile-friendly": 57856,
  "mobile-off": 57857,
  "mobile-screen-share": 57575,
  "mobiledata-off": 61492,
  "mode": 61591,
  "mode-comment": 57939,
  "mode-edit": 57940,
  "mode-edit-outline": 61493,
  "mode-fan-off": 60439,
  "mode-night": 61494,
  "mode-of-travel": 59342,
  "mode-standby": 61495,
  "model-training": 61647,
  "monetization-on": 57955,
  "money": 58749,
  "money-off": 57948,
  "money-off-csred": 61496,
  "monitor": 61275,
  "monitor-heart": 60066,
  "monitor-weight": 61497,
  "monochrome-photos": 58371,
  "mood": 59378,
  "mood-bad": 59379,
  "moped": 60200,
  "more": 58905,
  "more-horiz": 58835,
  "more-time": 59997,
  "more-vert": 58836,
  "mosque": 60082,
  "motion-photos-auto": 61498,
  "motion-photos-off": 59840,
  "motion-photos-on": 59841,
  "motion-photos-pause": 61991,
  "motion-photos-paused": 59842,
  "motorcycle": 59675,
  "mouse": 58147,
  "move-down": 60257,
  "move-to-inbox": 57704,
  "move-up": 60260,
  "movie": 57388,
  "movie-creation": 58372,
  "movie-edit": 63552,
  "movie-filter": 58426,
  "moving": 58625,
  "mp": 59843,
  "multiline-chart": 59103,
  "multiple-stop": 61881,
  "multitrack-audio": 57784,
  "museum": 59958,
  "music-note": 58373,
  "music-off": 58432,
  "music-video": 57443,
  "my-library-add": 57390,
  "my-library-books": 57391,
  "my-library-music": 57392,
  "my-location": 58716,
  "nat": 61276,
  "nature": 58374,
  "nature-people": 58375,
  "navigate-before": 58376,
  "navigate-next": 58377,
  "navigation": 58717,
  "near-me": 58729,
  "near-me-disabled": 61935,
  "nearby-error": 61499,
  "nearby-off": 61500,
  "nest-cam-wired-stand": 60438,
  "network-cell": 57785,
  "network-check": 58944,
  "network-locked": 58906,
  "network-ping": 60362,
  "network-wifi": 57786,
  "network-wifi-1-bar": 60388,
  "network-wifi-2-bar": 60374,
  "network-wifi-3-bar": 60385,
  "new-label": 58889,
  "new-releases": 57393,
  "newspaper": 60289,
  "next-plan": 61277,
  "next-week": 57706,
  "nfc": 57787,
  "night-shelter": 61937,
  "nightlife": 60002,
  "nightlight": 61501,
  "nightlight-round": 61278,
  "nights-stay": 59974,
  "no-accounts": 61502,
  "no-adult-content": 63742,
  "no-backpack": 62007,
  "no-cell": 61860,
  "no-crash": 60400,
  "no-drinks": 61861,
  "no-encryption": 58945,
  "no-encryption-gmailerrorred": 61503,
  "no-flash": 61862,
  "no-food": 61863,
  "no-luggage": 62011,
  "no-meals": 61910,
  "no-meals-ouline": 61993,
  "no-meeting-room": 60238,
  "no-photography": 61864,
  "no-sim": 57548,
  "no-stroller": 61871,
  "no-transfer": 61909,
  "noise-aware": 60396,
  "noise-control-off": 60403,
  "nordic-walking": 58638,
  "north": 61920,
  "north-east": 61921,
  "north-west": 61922,
  "not-accessible": 61694,
  "not-interested": 57395,
  "not-listed-location": 58741,
  "not-started": 61649,
  "note": 57455,
  "note-add": 59548,
  "note-alt": 61504,
  "notes": 57964,
  "notification-add": 58265,
  "notification-important": 57348,
  "notifications": 59380,
  "notifications-active": 59383,
  "notifications-none": 59381,
  "notifications-off": 59382,
  "notifications-on": 59383,
  "notifications-paused": 59384,
  "now-wallpaper": 57788,
  "now-widgets": 57789,
  "numbers": 60103,
  "offline-bolt": 59698,
  "offline-pin": 59658,
  "offline-share": 59845,
  "oil-barrel": 60437,
  "on-device-training": 60413,
  "ondemand-video": 58938,
  "online-prediction": 61675,
  "opacity": 59676,
  "open-in-browser": 59549,
  "open-in-full": 61902,
  "open-in-new": 59550,
  "open-in-new-off": 58614,
  "open-with": 59551,
  "other-houses": 58764,
  "outbond": 61992,
  "outbound": 57802,
  "outbox": 61279,
  "outdoor-grill": 59975,
  "outgoing-mail": 61650,
  "outlet": 61908,
  "outlined-flag": 57710,
  "output": 60350,
  "padding": 59848,
  "pages": 59385,
  "pageview": 59552,
  "paid": 61505,
  "palette": 58378,
  "pallet": 63594,
  "pan-tool": 59685,
  "pan-tool-alt": 60345,
  "panorama": 58379,
  "panorama-fish-eye": 58380,
  "panorama-fisheye": 58380,
  "panorama-horizontal": 58381,
  "panorama-horizontal-select": 61280,
  "panorama-photosphere": 59849,
  "panorama-photosphere-select": 59850,
  "panorama-vertical": 58382,
  "panorama-vertical-select": 61281,
  "panorama-wide-angle": 58383,
  "panorama-wide-angle-select": 61282,
  "paragliding": 58639,
  "park": 60003,
  "party-mode": 59386,
  "password": 61506,
  "pattern": 61507,
  "pause": 57396,
  "pause-circle": 57762,
  "pause-circle-filled": 57397,
  "pause-circle-outline": 57398,
  "pause-presentation": 57578,
  "payment": 59553,
  "payments": 61283,
  "paypal": 60045,
  "pedal-bike": 60201,
  "pending": 61284,
  "pending-actions": 61883,
  "pentagon": 60240,
  "people": 59387,
  "people-alt": 59937,
  "people-outline": 59388,
  "percent": 60248,
  "perm-camera-mic": 59554,
  "perm-contact-cal": 59555,
  "perm-contact-calendar": 59555,
  "perm-data-setting": 59556,
  "perm-device-info": 59557,
  "perm-device-information": 59557,
  "perm-identity": 59558,
  "perm-media": 59559,
  "perm-phone-msg": 59560,
  "perm-scan-wifi": 59561,
  "person": 59389,
  "person-2": 63716,
  "person-3": 63717,
  "person-4": 63718,
  "person-add": 59390,
  "person-add-alt": 59981,
  "person-add-alt-1": 61285,
  "person-add-disabled": 59851,
  "person-off": 58640,
  "person-outline": 59391,
  "person-pin": 58714,
  "person-pin-circle": 58730,
  "person-remove": 61286,
  "person-remove-alt-1": 61287,
  "person-search": 61702,
  "personal-injury": 59098,
  "personal-video": 58939,
  "pest-control": 61690,
  "pest-control-rodent": 61693,
  "pets": 59677,
  "phishing": 60119,
  "phone": 57549,
  "phone-android": 58148,
  "phone-bluetooth-speaker": 58907,
  "phone-callback": 58953,
  "phone-disabled": 59852,
  "phone-enabled": 59853,
  "phone-forwarded": 58908,
  "phone-in-talk": 58909,
  "phone-iphone": 58149,
  "phone-locked": 58910,
  "phone-missed": 58911,
  "phone-paused": 58912,
  "phonelink": 58150,
  "phonelink-erase": 57563,
  "phonelink-lock": 57564,
  "phonelink-off": 58151,
  "phonelink-ring": 57565,
  "phonelink-setup": 57566,
  "photo": 58384,
  "photo-album": 58385,
  "photo-camera": 58386,
  "photo-camera-back": 61288,
  "photo-camera-front": 61289,
  "photo-filter": 58427,
  "photo-library": 58387,
  "photo-size-select-actual": 58418,
  "photo-size-select-large": 58419,
  "photo-size-select-small": 58420,
  "php": 60303,
  "piano": 58657,
  "piano-off": 58656,
  "picture-as-pdf": 58389,
  "picture-in-picture": 59562,
  "picture-in-picture-alt": 59665,
  "pie-chart": 59076,
  "pie-chart-outline": 61508,
  "pie-chart-outlined": 59077,
  "pin": 61509,
  "pin-drop": 58718,
  "pin-end": 59239,
  "pin-invoke": 59235,
  "pinch": 60216,
  "pivot-table-chart": 59854,
  "pix": 60067,
  "place": 58719,
  "plagiarism": 59994,
  "play-arrow": 57399,
  "play-circle": 57796,
  "play-circle-fill": 57400,
  "play-circle-filled": 57400,
  "play-circle-outline": 57401,
  "play-disabled": 61290,
  "play-for-work": 59654,
  "play-lesson": 61511,
  "playlist-add": 57403,
  "playlist-add-check": 57445,
  "playlist-add-check-circle": 59366,
  "playlist-add-circle": 59365,
  "playlist-play": 57439,
  "playlist-remove": 60288,
  "plumbing": 61703,
  "plus-one": 59392,
  "podcasts": 61512,
  "point-of-sale": 61822,
  "policy": 59927,
  "poll": 59393,
  "polyline": 60347,
  "polymer": 59563,
  "pool": 60232,
  "portable-wifi-off": 57550,
  "portrait": 58390,
  "post-add": 59936,
  "power": 58940,
  "power-input": 58166,
  "power-off": 58950,
  "power-settings-new": 59564,
  "precision-manufacturing": 61513,
  "pregnant-woman": 59678,
  "present-to-all": 57567,
  "preview": 61893,
  "price-change": 61514,
  "price-check": 61515,
  "print": 59565,
  "print-disabled": 59855,
  "priority-high": 58949,
  "privacy-tip": 61660,
  "private-connectivity": 59204,
  "production-quantity-limits": 57809,
  "propane": 60436,
  "propane-tank": 60435,
  "psychology": 59978,
  "psychology-alt": 63722,
  "public": 59403,
  "public-off": 61898,
  "publish": 57941,
  "published-with-changes": 62002,
  "punch-clock": 60072,
  "push-pin": 61709,
  "qr-code": 61291,
  "qr-code-2": 57354,
  "qr-code-scanner": 61958,
  "query-builder": 59566,
  "query-stats": 58620,
  "question-answer": 59567,
  "question-mark": 60299,
  "queue": 57404,
  "queue-music": 57405,
  "queue-play-next": 57446,
  "quick-contacts-dialer": 57551,
  "quick-contacts-mail": 57552,
  "quickreply": 61292,
  "quiz": 61516,
  "quora": 60056,
  "r-mobiledata": 61517,
  "radar": 61518,
  "radio": 57406,
  "radio-button-checked": 59447,
  "radio-button-off": 59446,
  "radio-button-on": 59447,
  "radio-button-unchecked": 59446,
  "railway-alert": 59857,
  "ramen-dining": 60004,
  "ramp-left": 60316,
  "ramp-right": 60310,
  "rate-review": 58720,
  "raw-off": 61519,
  "raw-on": 61520,
  "read-more": 61293,
  "real-estate-agent": 59194,
  "rebase-edit": 63558,
  "receipt": 59568,
  "receipt-long": 61294,
  "recent-actors": 57407,
  "recommend": 59858,
  "record-voice-over": 59679,
  "rectangle": 60244,
  "recycling": 59232,
  "reddit": 60064,
  "redeem": 59569,
  "redo": 57690,
  "reduce-capacity": 61980,
  "refresh": 58837,
  "remember-me": 61521,
  "remove": 57691,
  "remove-circle": 57692,
  "remove-circle-outline": 57693,
  "remove-done": 59859,
  "remove-from-queue": 57447,
  "remove-moderator": 59860,
  "remove-red-eye": 58391,
  "remove-road": 60412,
  "remove-shopping-cart": 59688,
  "reorder": 59646,
  "repartition": 63720,
  "repeat": 57408,
  "repeat-on": 59862,
  "repeat-one": 57409,
  "repeat-one-on": 59863,
  "replay": 57410,
  "replay-10": 57433,
  "replay-30": 57434,
  "replay-5": 57435,
  "replay-circle-filled": 59864,
  "reply": 57694,
  "reply-all": 57695,
  "report": 57696,
  "report-gmailerrorred": 61522,
  "report-off": 57712,
  "report-problem": 59570,
  "request-page": 61996,
  "request-quote": 61878,
  "reset-tv": 59865,
  "restart-alt": 61523,
  "restaurant": 58732,
  "restaurant-menu": 58721,
  "restore": 59571,
  "restore-from-trash": 59704,
  "restore-page": 59689,
  "reviews": 61524,
  "rice-bowl": 61941,
  "ring-volume": 57553,
  "rocket": 60325,
  "rocket-launch": 60315,
  "roller-shades": 60434,
  "roller-shades-closed": 60433,
  "roller-skating": 60365,
  "roofing": 61953,
  "room": 59572,
  "room-preferences": 61880,
  "room-service": 60233,
  "rotate-90-degrees-ccw": 58392,
  "rotate-90-degrees-cw": 60075,
  "rotate-left": 58393,
  "rotate-right": 58394,
  "roundabout-left": 60313,
  "roundabout-right": 60323,
  "rounded-corner": 59680,
  "route": 60109,
  "router": 58152,
  "rowing": 59681,
  "rss-feed": 57573,
  "rsvp": 61525,
  "rtt": 59821,
  "rule": 61890,
  "rule-folder": 61897,
  "run-circle": 61295,
  "running-with-errors": 58653,
  "rv-hookup": 58946,
  "safety-check": 60399,
  "safety-divider": 57804,
  "sailing": 58626,
  "sanitizer": 61981,
  "satellite": 58722,
  "satellite-alt": 60218,
  "save": 57697,
  "save-alt": 57713,
  "save-as": 60256,
  "saved-search": 59921,
  "savings": 58091,
  "scale": 60255,
  "scanner": 58153,
  "scatter-plot": 57960,
  "schedule": 59573,
  "schedule-send": 59914,
  "schema": 58621,
  "school": 59404,
  "science": 59979,
  "score": 57961,
  "scoreboard": 60368,
  "screen-lock-landscape": 57790,
  "screen-lock-portrait": 57791,
  "screen-lock-rotation": 57792,
  "screen-rotation": 57793,
  "screen-rotation-alt": 60398,
  "screen-search-desktop": 61296,
  "screen-share": 57570,
  "screenshot": 61526,
  "screenshot-monitor": 60424,
  "scuba-diving": 60366,
  "sd": 59869,
  "sd-card": 58915,
  "sd-card-alert": 61527,
  "sd-storage": 57794,
  "search": 59574,
  "search-off": 60022,
  "security": 58154,
  "security-update": 61528,
  "security-update-good": 61529,
  "security-update-warning": 61530,
  "segment": 59723,
  "select-all": 57698,
  "self-improvement": 60024,
  "sell": 61531,
  "send": 57699,
  "send-and-archive": 59916,
  "send-time-extension": 60123,
  "send-to-mobile": 61532,
  "sensor-door": 61877,
  "sensor-occupied": 60432,
  "sensor-window": 61876,
  "sensors": 58654,
  "sensors-off": 58655,
  "sentiment-dissatisfied": 59409,
  "sentiment-neutral": 59410,
  "sentiment-satisfied": 59411,
  "sentiment-satisfied-alt": 57581,
  "sentiment-very-dissatisfied": 59412,
  "sentiment-very-satisfied": 59413,
  "set-meal": 61930,
  "settings": 59576,
  "settings-accessibility": 61533,
  "settings-applications": 59577,
  "settings-backup-restore": 59578,
  "settings-bluetooth": 59579,
  "settings-brightness": 59581,
  "settings-cell": 59580,
  "settings-display": 59581,
  "settings-ethernet": 59582,
  "settings-input-antenna": 59583,
  "settings-input-component": 59584,
  "settings-input-composite": 59585,
  "settings-input-hdmi": 59586,
  "settings-input-svideo": 59587,
  "settings-overscan": 59588,
  "settings-phone": 59589,
  "settings-power": 59590,
  "settings-remote": 59591,
  "settings-suggest": 61534,
  "settings-system-daydream": 57795,
  "settings-voice": 59592,
  "severe-cold": 60371,
  "shape-line": 63699,
  "share": 59405,
  "share-arrival-time": 58660,
  "share-location": 61535,
  "shelves": 63598,
  "shield": 59872,
  "shield-moon": 60073,
  "shop": 59593,
  "shop-2": 57758,
  "shop-two": 59594,
  "shopify": 60061,
  "shopping-bag": 61900,
  "shopping-basket": 59595,
  "shopping-cart": 59596,
  "shopping-cart-checkout": 60296,
  "short-text": 57953,
  "shortcut": 61536,
  "show-chart": 59105,
  "shower": 61537,
  "shuffle": 57411,
  "shuffle-on": 59873,
  "shutter-speed": 58429,
  "sick": 61984,
  "sign-language": 60389,
  "signal-cellular-0-bar": 61608,
  "signal-cellular-4-bar": 57800,
  "signal-cellular-alt": 57858,
  "signal-cellular-alt-1-bar": 60383,
  "signal-cellular-alt-2-bar": 60387,
  "signal-cellular-connected-no-internet-0-bar": 61612,
  "signal-cellular-connected-no-internet-4-bar": 57805,
  "signal-cellular-no-sim": 57806,
  "signal-cellular-nodata": 61538,
  "signal-cellular-null": 57807,
  "signal-cellular-off": 57808,
  "signal-wifi-0-bar": 61616,
  "signal-wifi-4-bar": 57816,
  "signal-wifi-4-bar-lock": 57817,
  "signal-wifi-bad": 61539,
  "signal-wifi-connected-no-internet-4": 61540,
  "signal-wifi-off": 57818,
  "signal-wifi-statusbar-4-bar": 61541,
  "signal-wifi-statusbar-connected-no-internet-4": 61542,
  "signal-wifi-statusbar-null": 61543,
  "signpost": 60305,
  "sim-card": 58155,
  "sim-card-alert": 58916,
  "sim-card-download": 61544,
  "single-bed": 59976,
  "sip": 61545,
  "skateboarding": 58641,
  "skip-next": 57412,
  "skip-previous": 57413,
  "sledding": 58642,
  "slideshow": 58395,
  "slow-motion-video": 57448,
  "smart-button": 61889,
  "smart-display": 61546,
  "smart-screen": 61547,
  "smart-toy": 61548,
  "smartphone": 58156,
  "smoke-free": 60234,
  "smoking-rooms": 60235,
  "sms": 58917,
  "sms-failed": 58918,
  "snapchat": 60014,
  "snippet-folder": 61895,
  "snooze": 57414,
  "snowboarding": 58643,
  "snowing": 59407,
  "snowmobile": 58627,
  "snowshoeing": 58644,
  "soap": 61874,
  "social-distance": 57803,
  "solar-power": 60431,
  "sort": 57700,
  "sort-by-alpha": 57427,
  "sos": 60407,
  "soup-kitchen": 59347,
  "source": 61892,
  "south": 61923,
  "south-america": 59364,
  "south-east": 61924,
  "south-west": 61925,
  "spa": 60236,
  "space-bar": 57942,
  "space-dashboard": 58987,
  "spatial-audio": 60395,
  "spatial-audio-off": 60392,
  "spatial-tracking": 60394,
  "speaker": 58157,
  "speaker-group": 58158,
  "speaker-notes": 59597,
  "speaker-notes-off": 59690,
  "speaker-phone": 57554,
  "speed": 59876,
  "spellcheck": 59598,
  "splitscreen": 61549,
  "spoke": 59815,
  "sports": 59952,
  "sports-bar": 61939,
  "sports-baseball": 59985,
  "sports-basketball": 59942,
  "sports-cricket": 59943,
  "sports-esports": 59944,
  "sports-football": 59945,
  "sports-golf": 59946,
  "sports-gymnastics": 60356,
  "sports-handball": 59955,
  "sports-hockey": 59947,
  "sports-kabaddi": 59956,
  "sports-martial-arts": 60137,
  "sports-mma": 59948,
  "sports-motorsports": 59949,
  "sports-rugby": 59950,
  "sports-score": 61550,
  "sports-soccer": 59951,
  "sports-tennis": 59954,
  "sports-volleyball": 59953,
  "square": 60214,
  "square-foot": 59977,
  "ssid-chart": 60262,
  "stacked-bar-chart": 59878,
  "stacked-line-chart": 61995,
  "stadium": 60304,
  "stairs": 61865,
  "star": 59448,
  "star-border": 59450,
  "star-border-purple500": 61593,
  "star-half": 59449,
  "star-outline": 61551,
  "star-purple500": 61594,
  "star-rate": 61676,
  "stars": 59600,
  "start": 57481,
  "stay-current-landscape": 57555,
  "stay-current-portrait": 57556,
  "stay-primary-landscape": 57557,
  "stay-primary-portrait": 57558,
  "sticky-note-2": 61948,
  "stop": 57415,
  "stop-circle": 61297,
  "stop-screen-share": 57571,
  "storage": 57819,
  "store": 59601,
  "store-mall-directory": 58723,
  "storefront": 59922,
  "storm": 61552,
  "straight": 60309,
  "straighten": 58396,
  "stream": 59881,
  "streetview": 58734,
  "strikethrough-s": 57943,
  "stroller": 61870,
  "style": 58397,
  "subdirectory-arrow-left": 58841,
  "subdirectory-arrow-right": 58842,
  "subject": 59602,
  "subscript": 61713,
  "subscriptions": 57444,
  "subtitles": 57416,
  "subtitles-off": 61298,
  "subway": 58735,
  "summarize": 61553,
  "sunny": 59418,
  "sunny-snowing": 59417,
  "superscript": 61714,
  "supervised-user-circle": 59705,
  "supervisor-account": 59603,
  "support": 61299,
  "support-agent": 61666,
  "surfing": 58645,
  "surround-sound": 57417,
  "swap-calls": 57559,
  "swap-horiz": 59604,
  "swap-horizontal-circle": 59699,
  "swap-vert": 59605,
  "swap-vert-circle": 59606,
  "swap-vertical-circle": 59606,
  "swipe": 59884,
  "swipe-down": 60243,
  "swipe-down-alt": 60208,
  "swipe-left": 60249,
  "swipe-left-alt": 60211,
  "swipe-right": 60242,
  "swipe-right-alt": 60246,
  "swipe-up": 60206,
  "swipe-up-alt": 60213,
  "swipe-vertical": 60241,
  "switch-access-shortcut": 59361,
  "switch-access-shortcut-add": 59362,
  "switch-account": 59885,
  "switch-camera": 58398,
  "switch-left": 61905,
  "switch-right": 61906,
  "switch-video": 58399,
  "synagogue": 60080,
  "sync": 58919,
  "sync-alt": 59928,
  "sync-disabled": 58920,
  "sync-lock": 60142,
  "sync-problem": 58921,
  "system-security-update": 61554,
  "system-security-update-good": 61555,
  "system-security-update-warning": 61556,
  "system-update": 58922,
  "system-update-alt": 59607,
  "system-update-tv": 59607,
  "tab": 59608,
  "tab-unselected": 59609,
  "table-bar": 60114,
  "table-chart": 57957,
  "table-restaurant": 60102,
  "table-rows": 61697,
  "table-view": 61886,
  "tablet": 58159,
  "tablet-android": 58160,
  "tablet-mac": 58161,
  "tag": 59887,
  "tag-faces": 58400,
  "takeout-dining": 60020,
  "tap-and-play": 58923,
  "tapas": 61929,
  "task": 61557,
  "task-alt": 58086,
  "taxi-alert": 61300,
  "telegram": 60011,
  "temple-buddhist": 60083,
  "temple-hindu": 60079,
  "terminal": 60302,
  "terrain": 58724,
  "text-decrease": 60125,
  "text-fields": 57954,
  "text-format": 57701,
  "text-increase": 60130,
  "text-rotate-up": 59706,
  "text-rotate-vertical": 59707,
  "text-rotation-angledown": 59708,
  "text-rotation-angleup": 59709,
  "text-rotation-down": 59710,
  "text-rotation-none": 59711,
  "text-snippet": 61894,
  "textsms": 57560,
  "texture": 58401,
  "theater-comedy": 60006,
  "theaters": 59610,
  "thermostat": 61558,
  "thermostat-auto": 61559,
  "thumb-down": 59611,
  "thumb-down-alt": 59414,
  "thumb-down-off-alt": 59890,
  "thumb-up": 59612,
  "thumb-up-alt": 59415,
  "thumb-up-off-alt": 59891,
  "thumbs-up-down": 59613,
  "thunderstorm": 60379,
  "tiktok": 60030,
  "time-to-leave": 58924,
  "timelapse": 58402,
  "timeline": 59682,
  "timer": 58405,
  "timer-10": 58403,
  "timer-10-select": 61562,
  "timer-3": 58404,
  "timer-3-select": 61563,
  "timer-off": 58406,
  "tips-and-updates": 59290,
  "tire-repair": 60360,
  "title": 57956,
  "toc": 59614,
  "today": 59615,
  "toggle-off": 59893,
  "toggle-on": 59894,
  "token": 59941,
  "toll": 59616,
  "tonality": 58407,
  "topic": 61896,
  "tornado": 57753,
  "touch-app": 59667,
  "tour": 61301,
  "toys": 58162,
  "track-changes": 59617,
  "traffic": 58725,
  "train": 58736,
  "tram": 58737,
  "transcribe": 63724,
  "transfer-within-a-station": 58738,
  "transform": 58408,
  "transgender": 58765,
  "transit-enterexit": 58745,
  "translate": 59618,
  "travel-explore": 58075,
  "trending-down": 59619,
  "trending-flat": 59620,
  "trending-neutral": 59620,
  "trending-up": 59621,
  "trip-origin": 58747,
  "trolley": 63595,
  "troubleshoot": 57810,
  "try": 61564,
  "tsunami": 60376,
  "tty": 61866,
  "tune": 58409,
  "tungsten": 61565,
  "turn-left": 60326,
  "turn-right": 60331,
  "turn-sharp-left": 60327,
  "turn-sharp-right": 60330,
  "turn-slight-left": 60324,
  "turn-slight-right": 60314,
  "turned-in": 59622,
  "turned-in-not": 59623,
  "tv": 58163,
  "tv-off": 58951,
  "two-wheeler": 59897,
  "type-specimen": 63728,
  "u-turn-left": 60321,
  "u-turn-right": 60322,
  "umbrella": 61869,
  "unarchive": 57705,
  "undo": 57702,
  "unfold-less": 58838,
  "unfold-less-double": 63695,
  "unfold-more": 58839,
  "unfold-more-double": 63696,
  "unpublished": 62006,
  "unsubscribe": 57579,
  "upcoming": 61566,
  "update": 59683,
  "update-disabled": 57461,
  "upgrade": 61691,
  "upload": 61595,
  "upload-file": 59900,
  "usb": 57824,
  "usb-off": 58618,
  "vaccines": 57656,
  "vape-free": 60358,
  "vaping-rooms": 60367,
  "verified": 61302,
  "verified-user": 59624,
  "vertical-align-bottom": 57944,
  "vertical-align-center": 57945,
  "vertical-align-top": 57946,
  "vertical-distribute": 57462,
  "vertical-shades": 60430,
  "vertical-shades-closed": 60429,
  "vertical-split": 59721,
  "vibration": 58925,
  "video-call": 57456,
  "video-camera-back": 61567,
  "video-camera-front": 61568,
  "video-chat": 63648,
  "video-collection": 57418,
  "video-file": 60295,
  "video-label": 57457,
  "video-library": 57418,
  "video-settings": 60021,
  "video-stable": 61569,
  "videocam": 57419,
  "videocam-off": 57420,
  "videogame-asset": 58168,
  "videogame-asset-off": 58624,
  "view-agenda": 59625,
  "view-array": 59626,
  "view-carousel": 59627,
  "view-column": 59628,
  "view-comfortable": 58410,
  "view-comfy": 58410,
  "view-comfy-alt": 60275,
  "view-compact": 58411,
  "view-compact-alt": 60276,
  "view-cozy": 60277,
  "view-day": 59629,
  "view-headline": 59630,
  "view-in-ar": 59902,
  "view-kanban": 60287,
  "view-list": 59631,
  "view-module": 59632,
  "view-quilt": 59633,
  "view-sidebar": 61716,
  "view-stream": 59634,
  "view-timeline": 60293,
  "view-week": 59635,
  "vignette": 58421,
  "villa": 58758,
  "visibility": 59636,
  "visibility-off": 59637,
  "voice-chat": 58926,
  "voice-over-off": 59722,
  "voicemail": 57561,
  "volcano": 60378,
  "volume-down": 57421,
  "volume-down-alt": 59292,
  "volume-mute": 57422,
  "volume-off": 57423,
  "volume-up": 57424,
  "volunteer-activism": 60016,
  "vpn-key": 57562,
  "vpn-key-off": 60282,
  "vpn-lock": 58927,
  "vrpano": 61570,
  "wallet": 63743,
  "wallet-giftcard": 59638,
  "wallet-membership": 59639,
  "wallet-travel": 59640,
  "wallpaper": 57788,
  "warehouse": 60344,
  "warning": 57346,
  "warning-amber": 61571,
  "wash": 61873,
  "watch": 58164,
  "watch-later": 59684,
  "watch-off": 60131,
  "water": 61572,
  "water-damage": 61955,
  "water-drop": 59288,
  "waterfall-chart": 59904,
  "waves": 57718,
  "waving-hand": 59238,
  "wb-auto": 58412,
  "wb-cloudy": 58413,
  "wb-incandescent": 58414,
  "wb-iridescent": 58422,
  "wb-shade": 59905,
  "wb-sunny": 58416,
  "wb-twighlight": 59906,
  "wb-twilight": 57798,
  "wc": 58941,
  "web": 57425,
  "web-asset": 57449,
  "web-asset-off": 58615,
  "web-stories": 58773,
  "webhook": 60306,
  "wechat": 60033,
  "weekend": 57707,
  "west": 61926,
  "whatshot": 59406,
  "wheelchair-pickup": 61867,
  "where-to-vote": 57719,
  "widgets": 57789,
  "width-full": 63733,
  "width-normal": 63734,
  "width-wide": 63735,
  "wifi": 58942,
  "wifi-1-bar": 58570,
  "wifi-2-bar": 58585,
  "wifi-calling": 61303,
  "wifi-calling-3": 61573,
  "wifi-channel": 60266,
  "wifi-find": 60209,
  "wifi-lock": 57825,
  "wifi-off": 58952,
  "wifi-password": 60267,
  "wifi-protected-setup": 61692,
  "wifi-tethering": 57826,
  "wifi-tethering-error": 60121,
  "wifi-tethering-error-rounded": 61574,
  "wifi-tethering-off": 61575,
  "wind-power": 60428,
  "window": 61576,
  "wine-bar": 61928,
  "woman": 57662,
  "woman-2": 63719,
  "woo-commerce": 60013,
  "wordpress": 60063,
  "work": 59641,
  "work-history": 60425,
  "work-off": 59714,
  "work-outline": 59715,
  "workspace-premium": 59311,
  "workspaces": 57760,
  "workspaces-filled": 59917,
  "workspaces-outline": 59919,
  "wrap-text": 57947,
  "wrong-location": 61304,
  "wysiwyg": 61891,
  "yard": 61577,
  "youtube-searched-for": 59642,
  "zoom-in": 59647,
  "zoom-in-map": 60205,
  "zoom-out": 59648,
  "zoom-out-map": 58731
}
